import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from 'vue-router';
import { useStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const store = useStore();

let routeChecked = false;

router.beforeEach((to) =>
{
    if (routeChecked)
        return;

    routeChecked = true;

    if (!!to.query.app)
    {
        store.app.value = parseInt(to.query.app.toString()) || 1;
        store.appSwitch.value = to.name === 'appSwitch';
    }

    if (!!to.query.r)
        store.returnUrl.value = to.query.r.toString();

});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})